export const ADD_IDENTITY = 'ADD_IDENTITY';

export const addIdentity = data => {
    return { type: ADD_IDENTITY, data: data }
};
